module.exports = __webpack_public_path__ + "static/media/caret-up.26d95842.svg";